import { useCallback, useEffect, useRef, useState } from 'react';

export const useSafeState = <T,>(inititialValue: T) => {
  const [st, setSt] = useState(inititialValue);

  const isUnmountRef = useRef(false);
  useEffect(
    () => () => {
      isUnmountRef.current = true;
    },
    []
  );

  const setter: typeof setSt = useCallback(
    (...args: Parameters<typeof setSt>) => {
      if (isUnmountRef.current) return;
      setSt(...args);
    },
    []
  );

  return [st, setter] as const;
};
